import { createSelector } from 'reselect';
import { pickBy } from 'lodash';
import { ILocaleState } from './reducer';

export const getCurrentLocale = createSelector(
  (store: any) => {
    return store.localeSettings;
  },
  (localeSettings: ILocaleState) => {
    return localeSettings.currentLocale;
  },
);

export const getMessages = createSelector(
  getCurrentLocale,
  (store: any) => {
    return store.localeSettings.allMessages;
  },
  (currentLocale: string, allMessages: any) => {
    return allMessages[currentLocale] || allMessages.en;
  },
);

export const makeGetMessagesByIdIncludes = (matchString: string) => {
  return createSelector(
    getMessages,
    allMessages => {
      return pickBy(allMessages, (value, key) => {
        return key.includes(matchString);
      });
    },
  );
};



// WEBPACK FOOTER //
// ./src/containers/LocaleSettings/selectors.ts